
export const projetos = [
  {
    id: 'sunset-villas-tampa',
    nome: 'Acabamentos Premium',
    localizacao: 'Citrus Spring, FL',
    status: 'Oportunidade',
    prazo: '9 meses',
    descricao: 'Residências modernas de alto padrão com 4 quartos, e acabamento premium. Mercado muito aquecido.',
    imagem: 'https://static.readdy.ai/image/adbcdcc03ccb95572cdcd393dd2136c2/f391eda3a0329cfc855b3af20cef968f.png',
    investimentoMinimo: '$22,000',
    retornoEstimado: '16-18%',
    areaConstruida: '220m²',
    quartos: 4,
    banheiros: 2,
    vagas: 2,
    detalhes: 'Projeto localizado em área de alta valorização em Citrus Spring, com infraestrutura completa e acesso facilitado. Casas com design contemporâneo, acabamento de primeira linha e área de lazer privativa.',
  },
  {
    id: 'palm-gardens-orlando',
    nome: 'Modelo Casa',
    localizacao: 'Citrus Spring, FL',
    status: 'Investimento',
    prazo: '10 meses',
    descricao: 'Área verde em uma cidade em franca expansão, aproximadamente 1h de Orlando.',
    imagem: 'https://static.readdy.ai/image/adbcdcc03ccb95572cdcd393dd2136c2/dcb38a566d4496e765f76dd519f23df6.png',
    investimentoMinimo: '$22,000',
    retornoEstimado: '15-17%',
    areaConstruida: '195m²',
    quartos: 3,
    banheiros: 2,
    vagas: 2,
    detalhes: 'Condomínio planejado com infraestrutura completa, próximo às principais atrações de Orlando. Ideal para investimento em locação de curta temporada.',
  },
  {
    id: 'coastal-homes-clearwater',
    nome: 'Investimento seguro',
    localizacao: 'Citrus Spring, FL',
    status: 'Único',
    prazo: 'Concluído',
    descricao: 'Casas aconchegantes com design moderno e com grande interesse para primary home por americano.',
    imagem: 'https://static.readdy.ai/image/adbcdcc03ccb95572cdcd393dd2136c2/994356c91b468b974024c6bb4a871eef.png',
    investimentoMinimo: '$22,000',
    retornoEstimado: '18-20%',
    areaConstruida: '250m²',
    quartos: 4,
    banheiros: 3,
    vagas: 2,
    detalhes: 'Projeto concluído com sucesso, todas as unidades entregues dentro do prazo. Localização privilegiada com acesso direto à praia e alta demanda para locação.',
  },
];
